import React from "react";
import { FaUserTie } from "react-icons/fa";
import chooseImg from './images/choose-img.jpg'
import useIntersectionObserver from "./home-animation";
export default function HomeChoose() {
    const [sectionRef1, isVisible1] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef2, isVisible2] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef3, isVisible3] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef4, isVisible4] = useIntersectionObserver({ threshold: 0.1 });
    const [sectionRef5, isVisible5] = useIntersectionObserver({ threshold: 0.1 });
    return (
        <div className="home-choose">
            <div className="outer-container">
            <div className="home-inner-choose-overlay"></div>
                <div className="home-inner-choose">
                   <div className="home-inner-choose-left">
                    <div className="home-inner-choose-left-inner">
                        <div className="home-choose-box">
                        <div className={`home-inner-choose-left-box ${isVisible1 ? 'animate__fadeInLeft' : '' }`} style={{ animationDuration: '1.25s' }} ref={sectionRef1}>
                            <div className="home-choose-icon">
                                <FaUserTie/>
                            </div>
                            <div className="home-choose-contnet">
                            <div className="choose-head">Insights from Real Employees</div>
                            <p className="main-para">Discover genuine perspectives from employees that shape your career decisions. Gain valuable insights into company cultures and work environments.</p>
                            </div>
                        </div>
                        </div>
                        <div className="home-choose-seperater"></div>
                    </div>

                    <div className="home-inner-choose-left-inner">
                        <div className="home-choose-box">
                        <div className={`home-inner-choose-left-box ${isVisible2 ? 'animate__fadeInLeft' : '' }`} style={{ animationDuration: '1.25s' }} ref={sectionRef2}>
                            <div className="home-choose-icon">
                                <FaUserTie/>
                            </div>
                            <div className="home-choose-contnet">
                            <div className="choose-head">Comprehensive ratings</div>
                            <p className="main-para">Evaluate companies with detailed ratings and reviews. Make informed decisions based on comprehensive data and user feedback.</p>
                            </div>
                        </div>
                        </div>
                        <div className="home-choose-seperater"></div>
                    </div>

                    <div className="home-inner-choose-left-inner">
                        <div className="home-choose-box">
                        <div className={`home-inner-choose-left-box ${isVisible3 ? 'animate__fadeInLeft' : '' }`} style={{ animationDuration: '1.25s' }} ref={sectionRef3}>
                            <div className="home-choose-icon">
                                <FaUserTie/>
                            </div>
                            <div className="home-choose-contnet">
                            <div className="choose-head">Expert Talent Acquisition Support</div>
                            <p className="main-para">Gain access to personalized guidance and strategies tailored to enhance your talent acquisition efforts. Our experts provide insights and resources to streamline your hiring process and attract top-tier candidates.</p>
                            </div>
                        </div>
                        </div>
                    </div>
                   </div>
                   <div className="home-inner-choose-right">
                   <div className="home-whatwe-head mb-1 mb-md-3">Why Choose Us</div>
                   <div className={`home-whatwe-mainhead mb-3 ${isVisible4 ? 'animate__fadeInRight' : ''}`} style={{ animationDuration: '1.25s' }} ref={sectionRef4}>Empower Your Hiring Strategy</div>
                   <p className="main-para ">Empower your recruitment strategy with our comprehensive platform. Discover top talent, gain valuable industry insights, and receive expert guidance to streamline your hiring process effectively.</p>
                   <img src={chooseImg} alt="chooseImg" className={`img-fluid home-choose-img ${isVisible5? 'animate__fadeInUp' : ''}`} width="1280" height="893" style={{ animationDuration: '1.25s' }} ref={sectionRef5}/>
                   </div>
                </div>
            </div>
        </div>
    );
}
